import { AlertEntity, AlertBikeEntity, AlertZoneEntity } from "../types/alert"

export const groupAlerts = (alerts: AlertEntity[]) => {
  return alerts.reduce((acc, alert) => {
    if (!alert.extra) return acc
    if (alert.alert_type.includes("bicycle") || alert.alert_type.includes("lock")) {
      const extra = alert.extra as AlertBikeEntity
      if (acc[extra.bicycle_uuid]) {
        acc[extra.bicycle_uuid].alerts.push(alert)
      } else {
        acc[extra.bicycle_uuid] = { bicycle: extra, alerts: [alert] }
      }
    } else if (alert.alert_type.includes("zone")) {
      const extra = alert.extra as AlertZoneEntity
      if (acc[extra.zone_uuid]) {
        acc[extra.zone_uuid].alerts.push(alert)
      } else {
        acc[extra.zone_uuid] = { zone: extra, alerts: [alert] }
      }
    }
    return acc
  }, {} as { [key: string]: { alerts: AlertEntity[]; bicycle?: AlertBikeEntity; zone?: AlertZoneEntity } })
}
